import React from "react";
import { Database } from "lucide-react";

const EmptyState = ({ message }) => {
  return (
    <div className="empty-state">
      <Database className="icon" />
      <h3>No Data Contracts Found</h3>
      <p>{message}</p>
    </div>
  );
};

export default EmptyState;
